import { Injectable } from '@angular/core';
import { ConnectionService } from '../connection/connection.service';
import { AppConstants } from '../../entity/constants';
import { ApproachType, OptimizationType, TransactionType } from '../../entity/optimise';

@Injectable({
  providedIn: 'root'
})
export class OptimizationService {

  constructor(private readonly connectionService: ConnectionService) { }

  /**
   * Method to fetch the optimized sequence of stops and tasks for a given 
   * route based on the selected optimization approach and transaction type.
   * @param params - An object containing routeId, optimizationType, approachType, and transactionType
   * optimizationType: The type of optimization to be performed, either 'OPTIMIZE' or 'SLOTIN'.
   * approachType: The approach to be used for optimization, which can be 'Unrestricted', 'Vehicle', or 'Curb'.
   * transactionType: The type of transaction, either 'Preview' for a non-committal optimization or 'Commit' for finalizing the optimization.
   * @returns An observable containing the optimized sequence of stops and tasks
   * KPIs like drive time, distance, and other relevant metrics.
   */
  getOptimizedSequence(params: {
    routeId: string, 
    optimizationType: OptimizationType, 
    approachType: ApproachType, 
    transactionType: TransactionType
  }, isLoader = false) {
    let queryParams = {
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.DPOPTIMIZATION}?${AppConstants.TRANSACTION_TYPE}=${params.transactionType}&${AppConstants.TYPE}=${params.optimizationType}&routeId=${params.routeId}&${AppConstants.APPROACH_TYPE}=${params.approachType}`,
      directoryType: AppConstants.RPS,
      isLoader: isLoader,
      responseType: params.transactionType === TransactionType.PREVIEW ? 'json' : 'text' // Expect JSON for preview and text for commit
    };
    return this.connectionService.httpReq(queryParams);
  }

}
